module.exports = __webpack_public_path__ + "static/media/connect-stripe-step-one.cdf637ed.png";